'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /web0s(?!.*chrome)/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/environment-is-webos-webkit.js
// module id = 672
// module chunks = 0